import React, { useEffect, useState } from "react";
import "swiper/css";
import { Divider, Pagination, Select, Spin } from "antd";
import NavigationButtons from "@/pages/home/section/sectionJobByMajor/components/NavigationButtons";
import NavigationButton from "@/pages/home/section/sectionJobNew/components/NavigationButton";
import { Swiper, SwiperSlide } from "swiper/react";
import JobCard from "@/pages/home/section/sectionJobNew/components/JobCard";
import JobService from "@/services/JobService";
import OptionService from "@/services/OptionService";
import { EmptyComponent } from "@/components/ui/EmptyComponent";
import { LoadingOutlined } from "@ant-design/icons";

const SectionJobNew = () => {
    const ITEM_PER_PAGE = 9;
    const [swiperRef, setSwiperRef] = useState(null);
    const [jobs, setJobs] = useState([]);
    // const [filteredJobs, setFilteredJobs] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [jobCategories, setJobCategories] = useState([]);
    const [filterOptions, setFilterOptions] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState("J001");
    const [selectedFilter, setSelectedFilter] = useState("ALL");
    const [load, setLoad] = useState(true);
    const [query, setQuery] = useState({
        j001: "ALL",
        j003: "ALL",
        j009: "ALL",
    })

    useEffect(() => {
        setLoad(true)
        JobService.getQuery(query).then((res) => {
            setJobs(res);
            setLoad(false)
        }).catch((err) => {
            console.error(err);
        });
    }, [query]);

    useEffect(() => {
        OptionService.getOption().then((res) => {
            const groupedData = res.Data.reduce((acc, item) => {
                if (["J001", "J003", "J009"].includes(item.ParentCode)) {
                    if (!acc[item.ParentCode]) {
                        acc[item.ParentCode] = {
                            label: item.ParentCodeName,
                            options: [
                                {
                                    value: "ALL",
                                    label: `Tất cả ${item.ParentCodeName}`
                                }
                            ]
                        };
                    }
                    acc[item.ParentCode].options.push({
                        value: item.Code,
                        label: item.Name
                    });
                }
                return acc;
            }, {});
            setJobCategories(groupedData);
            setSelectedCategory("J001");
            setFilterOptions(groupedData["J001"]?.options || []);
            if (groupedData["J001"]?.options?.length > 0) {
                setSelectedFilter(groupedData["J001"].options[0].value);
                handleFilterChange(groupedData["J001"].options[0].value);
            }
        }).catch(() => {
            console.error("Error");
        });
    }, []);

    useEffect(() => {
        setCurrentPage(1)
        setQuery({
            nghenghiepId: selectedCategory === "J001" ? selectedFilter : "ALL",
            locationId: selectedCategory === "J003" ? selectedFilter : "ALL",
            salaryId: selectedCategory === "J009" ? selectedFilter : "ALL",
        })
    }, [selectedCategory, selectedFilter])

    const page = jobs.slice((currentPage - 1) * ITEM_PER_PAGE, currentPage * ITEM_PER_PAGE);

    const onChange = (page) => {
        setCurrentPage(page);
    }

    const handleCategoryChange = (category) => {
        setSelectedCategory(category);
        setFilterOptions(jobCategories[category]?.options || []);
        handleFilterChange("ALL");
    }

    const handleFilterChange = (value) => {
        if (selectedFilter !== value) {
            setSelectedFilter(value);
        }
    };
    return (
        <div className={"p-4 min-h-[600px] space-y-2"}>
            <div className={"mb-4 h-full"}>
                <Divider
                    className="font-bold uppercase w-full"
                    style={{ borderColor: "#7cb305" }}
                    align="center"
                    orientation="center"
                >
                    <h1 className="lg:text-3xl text-md font-bold text-green-700">
                        Việc làm mới nhất
                    </h1>
                    <p className="lg:text-sm text-xs text-gray-500">
                        Cập nhật những công việc mới nhất từ chúng tôi.
                    </p>
                </Divider>
            </div>
            <div className={"flex flex-col md:flex-row gap-4 md:gap-6 items-center"}>
                <Select className={"w-full md:w-1/4 h-10"}
                    onChange={handleCategoryChange}
                    options={Object.entries(jobCategories).map(([key, group]) => ({
                        label: group.label,
                        value: key,
                    }))}
                    value={selectedCategory}
                />
                <div className="flex w-full md:hidden h-10">
                    <Select className={"w-full h-full"}
                        onChange={(e) => handleFilterChange(e)}
                        options={filterOptions}
                        // fieldNames={{ value: "", label: "" }}
                        value={selectedFilter}
                    />
                </div>
                <div className={"w-full md:w-3/4 hidden md:flex items-center gap-4"}>
                    <NavigationButton
                        direction={"prev"}
                        onClick={() => swiperRef?.slidePrev()}
                    />
                    <div className={"flex-1 overflow-hidden"}>
                        <Swiper
                            slidesPerView={'auto'}
                            onSwiper={setSwiperRef}
                            spaceBetween={16}
                            navigation={{
                                nextEl: "#next",
                                prevEl: "#prev",
                            }}
                            modules={[NavigationButtons]}
                            className={"!px-2"}
                        >
                            {filterOptions.map((option, index) => (
                                <SwiperSlide key={index} className={"!w-auto"}>
                                    <button
                                        className={`px-4 py-2 rounded-full transition-all duration-200 text-sm whitespace-nowrap
                                        ${selectedFilter === option.value
                                                ? "bg-green-600 text-white shadow-lg transform scale-105"
                                                : "bg-gray-100 text-gray-700 hover:bg-gray-200"
                                            }`}
                                        onClick={() => handleFilterChange(option.value)}
                                    >
                                        {option.label}
                                    </button>
                                </SwiperSlide>
                            ))}
                        </Swiper>
                    </div>
                    <NavigationButton
                        direction={"next"}
                        onClick={() => swiperRef?.slideNext()}
                    />
                </div>
            </div>
            <div className={"min-h-[400px]"}>
                {!load && jobs.length === 0 && (

                    <div className="w-full h-[400px]  flex items-center justify-center">
                        <EmptyComponent description={"Công ty"} />
                    </div>
                )}
                {load && (
                    <div className="w-full h-[400px]  flex items-center justify-center">
                        <Spin indicator={<LoadingOutlined style={{ fontSize: 80 }} spin />} />
                    </div>
                )}

                {!load && jobs.length > 0 && (
                    <>
                        <div className={"grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 mt-6 gap-4"}>
                            {page.map((job) => (
                                <JobCard job={job} key={job.Pk} />
                            ))}
                        </div>
                        {!jobs.length && (
                            <EmptyComponent description={"công việc"} />
                        )}
                    </>
                )}
            </div>
            {!load && jobs.length > 0 && (
                <div className={"flex justify-center"}>
                    <Pagination
                        align="center"
                        current={currentPage}
                        total={jobs.length}
                        pageSize={ITEM_PER_PAGE}
                        onChange={onChange}
                        showSizeChanger={false}
                        showQuickJumper={false}
                    />
                </div>
            )}

        </div>
    );
};

export default SectionJobNew;